import qs from 'qs';
import * as React from 'react';
import { withRouter } from 'react-router';
import { clearFiltersFromSearch } from './utils/clearFiltersFromSearch';
import { formatFilter, formatFromState } from './utils/formatFilter';
import { replaceInSearch } from './utils/replaceInSearch';
const typeMap = {
    listFilters: 'list',
    rangeFilters: 'range',
    booleanFilters: 'boolean',
    multiListFilters: 'multiList'
};
class IFilterParam extends React.Component {
    constructor() {
        super(...arguments);
        this.clearAll = () => {
            clearFiltersFromSearch({
                history: this.props.history,
                location: this.props.location
            });
        };
    }
    shouldComponentUpdate(nextProps) {
        if (nextProps.lastChangedFilterType === null)
            return false;
        if (this.props.lastChangedFilterType === 'all' &&
            nextProps.lastChangedFilterType === 'all')
            return false;
        // Bail out of render if the filters weren't updated.
        // In this case, this component re-rendered because the params changed
        if (nextProps.lastChangedFilterType !== 'all' &&
            nextProps.activeFilters[nextProps.lastChangedFilterType] ===
                this.props.activeFilters[nextProps.lastChangedFilterType])
            return false;
        return true;
    }
    componentDidMount() {
        const initialSearchParams = qs.parse(this.props.location.search, {
            ignoreQueryPrefix: true
        });
        // Get the arguments that appear in the initial search
        const queryArgs = Object.keys(initialSearchParams);
        // Check if any of the arguments are filters
        const types = Object.values(typeMap);
        const paramsContainFilter = queryArgs.some(key => types.includes(key));
        if (paramsContainFilter) {
            // Get any persisted filters from state
            const newActiveFilters = Object.values(typeMap).reduce((res, filterType) => {
                if (initialSearchParams[filterType]) {
                    return Object.assign({}, res, { [`${filterType}Filters`]: formatFilter[filterType](initialSearchParams) });
                }
                return res;
            }, this.props.activeFilters);
            this.props.applyFilters(newActiveFilters);
        }
    }
    componentDidUpdate() {
        // Which filter type triggered this update?
        const { lastChangedFilterType } = this.props;
        if (lastChangedFilterType === 'all') {
            this.clearAll();
            return;
        }
        // Format from the data structure we use in state to the data structure used
        // in the URL params
        const formatted = formatFromState[typeMap[lastChangedFilterType]](this.props.activeFilters[lastChangedFilterType]);
        // Stringify the data to be persisted in the URL
        const stringy = qs.stringify(formatted, {
            encodeValuesOnly: true
        });
        // Update the URL, preserving other applied filters and params
        replaceInSearch({
            history: this.props.history,
            location: this.props.location,
            queryString: stringy,
            replaceType: true,
            routeType: 'filterChange'
        });
    }
    render() {
        return null;
    }
}
export default withRouter(IFilterParam);
//# sourceMappingURL=FilterParams.js.map